import { useCallback, useMemo } from 'react';
import { emitAck } from '../adminEmit';

export function useAdminAuditApi(socket) {
  const listAudit = useCallback(
    (params) => emitAck(socket, 'admin:audit:list', params),
    [socket]
  );

  return useMemo(() => ({ listAudit }), [listAudit]);
}
